
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { mockProducts } from '../../../mocks/products';
import ProductHero from './components/ProductHero';
import ProductInfo from './components/ProductInfo';
import ProductFeatures from './components/ProductFeatures';
import RelatedProducts from './components/RelatedProducts';

export default function ProductDetailPage() {
  const { id } = useParams<{ id: string }>();
  const product = mockProducts.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-40 pb-32 text-center">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-gray-100 rounded-full">
            <i className="ri-error-warning-line text-3xl text-gray-400"></i>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Product Not Found</h1>
          <p className="text-gray-500 mb-8">
            The product you are looking for does not exist or has been removed.
          </p>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-6 py-3 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Products
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const relatedProducts = mockProducts
    .filter((p) => p.category === product.category && p.id !== product.id)
    .slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ProductHero product={product} />
      <ProductInfo product={product} />
      <ProductFeatures product={product} />
      {relatedProducts.length > 0 && <RelatedProducts products={relatedProducts} />}
      <Footer />
    </div>
  );
}
